import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { GlassCard, SectionShell } from './LandingPrimitives';

const staffFeatures = [
  'Digital shift assignment',
  'Attendance tracking',
  'Prevent offline bookings',
  'Staff performance insights',
  'Task dashboard',
];

const StaffSection = () => {
  return (
    <SectionShell
      id="staff"
      eyebrow="Staff Management"
      title="Run operations with accountability"
      description="Track team attendance, task completion, and shift ownership so no booking falls through the cracks."
    >
      <div className="grid gap-6 lg:grid-cols-2">
        <GlassCard>
          <ul className="space-y-3">
            {staffFeatures.map((feature) => (
              <li key={feature} className="flex items-center gap-3 text-sm text-ga-text-muted">
                <CheckCircle2 className="h-4 w-4 text-ga-primary" />
                {feature}
              </li>
            ))}
          </ul>
        </GlassCard>
        <GlassCard className="relative overflow-hidden p-0">
          <p className="mb-3 px-5 pt-5 text-xs uppercase tracking-[0.16em] text-ga-text-subtle">Role &amp; Staff Console</p>
          <img
            src={`${process.env.PUBLIC_URL}/images/preview-staff.png`}
            alt="GroundAale role management showing Staff and Viewer roles with module-level permissions"
            className="w-full rounded-b-xl"
            loading="lazy"
          />
        </GlassCard>
      </div>
    </SectionShell>
  );
};

export default StaffSection;
